import { SocketEvent } from "../SocketEvent";
import { SocketEventInterface } from "../SocketEventInterface";
import Constants from "../../Action/Constants";

class PaymentCreate extends SocketEvent implements SocketEventInterface {

  protected props: any;

  constructor() {
    super();
  }

  public process(): void {
    this.props.dispatch({
      type: Constants.GLOBAL_PAYMENT_CREATE_SUCCESS
    });
    
    this.props.dispatch({
      type: Constants.GLOBAL_PAYMENTS_LIST_OUTDATE_REQUESTS
    });

    this.props.dispatch({
      type: Constants.GLOBAL_CHARGES_LIST_OUTDATE_REQUESTS
    })
  }
}

export { PaymentCreate };
